import moment from "moment";
import { have_product_reference } from "./OrdersFunctionsGlobal";
import { formatDateMinus, formatDatePlus } from "./Utils";

export const orderRowFilteredForBulk = (order_rows, { supp_date }) => {
  if (order_rows.length == 0) return [];

  const order_rows_filter = order_rows.map((order_row) => {
    let manual_disabled = false;
    if (!have_product_reference(order_row.product_reference))
      manual_disabled = true;
    if (!manual_disabled && !order_row.supplyings.length)
      manual_disabled = true;
    if (!manual_disabled && order_row.disabled_at) manual_disabled = true;
    if (!manual_disabled && +order_row.quantity <= +order_row.shipments_count)
      manual_disabled = true;
    if (
      !manual_disabled &&
      !order_row.supplyings.some((supplying) =>
        supplyingsFilterByDate(supplying, supp_date)
      )
    ) {
      manual_disabled = true;
    }

    const supplyings = order_row.supplyings.map((supplying) => {
      if (manual_disabled || supplying.used_at)
        return {
          ...supplying,
          manual_disabled: true,
        };
      if (supplyingsFilterByDate(supplying, supp_date))
        return {
          ...supplying,
          manual_disabled: false,
        };

      return {
        ...supplying,
        manual_disabled: true
      }
    });

    return {
      ...order_row,
      supplyings,
      manual_disabled:
        manual_disabled ||
        supplyings.every((supplying) => supplying?.manual_disabled),
    };
  });

  return order_rows_filter;
};

const supplyingsFilterByDate = (supplying, supp_date) => {
  if (!supplying.date) return false;
  if (!supp_date) return false
  if (supp_date[0]) {
    const is_after = moment(supplying.date).isAfter(formatDateMinus(supp_date[0]));
    if (!is_after) return false
  }
  if (supp_date[1]) {
    const is_before = moment(supplying.date).isBefore(formatDatePlus(supp_date[1]));
    if (!is_before) return false
  }
  return true
}
